/* eslint-disable */
import { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { usePosterReducers } from "../../../../../redux/getdata/usePostReducer";
import { useWebSocket } from "../../../../api/websocket/WebSocketContext";
import { BLOG_PAGE_URL } from "../../../../constant/url";
import { BlogForm } from "../../../../utils/staticdata";
import { AddBlogTypes } from "../../../../utils/types";
import FormLayout from "../../../components/FormLayout";
import UploadImage from "../../../components/UploadImage";
import InputField from "../../../components/input/InputField";
import TextEditor from "../../../components/input/TextEditor";

const AddBlog = () => {
  const { setError,control, reset, handleSubmit, register, setValue ,formState:{errors}, clearErrors,
} =
    useForm<AddBlogTypes>();
    const { send, receivedMessage, isConnect } = useWebSocket();
    const { blogs_list } = usePosterReducers()
    const param = useParams();

    const matchData  = blogs_list?.data?.find((row)=>row?.id===param?.id)
     
    const dispatch = useDispatch();
    const navigate = useNavigate();
  
    const location = useLocation();
    const [initialImageUrls, setInitialImageUrls] = useState<string[]>([]);
    const ref = useRef<HTMLDivElement>(null);
  
    useEffect(() => {
      if (isConnect) {
        if (receivedMessage) {
          if (receivedMessage?.url === "blog_add") {
            if(receivedMessage?.response?.status===200)
              toast.success(receivedMessage?.response?.msg);
              navigate(BLOG_PAGE_URL);
          }
          if (receivedMessage?.url === "blog_update") {
            if(receivedMessage?.response?.status===200)
              toast.success(receivedMessage?.response?.msg);
            navigate(BLOG_PAGE_URL);
          }
        }
      }
    }, [receivedMessage, dispatch]);

     useEffect(() => {
      if(param.id!=='') { if (location.pathname.split("/")[3] === "update-blog") {
        reset({
          title:matchData?.title,
          description:matchData?.description,
          keywords:matchData?.keywords,
          // image:matchData?.images[0],
          // image:"https://nwchat.s3.amazonaws.com/media/files/fc08c9b8-80e8-4e00-b35c-cd6ca2bdd098.webp",
        });
        setInitialImageUrls(matchData?.images[0] ? [matchData.images[0]] : []);

        }}
     }, [isConnect, receivedMessage?.url]);
  

  const onSubmit = (data: AddBlogTypes) => {
    if ("image" in data) {
      if (!data.image) {
      if (ref.current) ref.current.scrollIntoView({ behavior: "smooth" });
        setError("image", {
          type: "manual",
          message: "Image is required",
        });
        return;
      }

    } else {
      setError("image", {
        type: "manual",
        message: "Image is required",
      });

      if (ref.current) ref.current.scrollIntoView({ behavior: "smooth" });
      return;
    }

    if (location.pathname.split("/")[3] === "update-blog"){
      const payload =    {
        "transmit": "single",
        "url": "blog_update",
        "request": {
        "blog_id":param?.id,
        "title":data?.title,
        "images" :[data?.image],
        "description": data?.description,
        "keywords": data?.keywords
        }
          }
         send(payload)
    }else{
      const payload =    {
     "transmit": "single",
     "url": "blog_add",
     "request": {
     "title":data?.title,
     "images" :[data?.image],
     "description": data?.description,
     "keywords": data?.keywords
     }
       }
      send(payload)
    }


  };
  return (
    <FormLayout
      containt={BlogForm}
      handleSubmit={handleSubmit}
      onSubmit={onSubmit}
    >
       <div ref={ref}>
            <UploadImage
              initialImageUrls={initialImageUrls}
              singleUpload
              setValue={setValue}
              error={errors?.image}
              clearError={clearErrors}
              required
              name="image"
              title="Blog Image"
            />
          </div>
      <div className="lg:flex w-full gap-4">
        <InputField
          name={"Title"}
          placeholder={"Enter title"}
          className="my-2 w-full"
          inputClassName="h-9"
          required
              error={errors?.title}
              register={{
                ...register("title", {
                  required: "Title is required",
                  maxLength: {
                    value: 256,
                    message: "title cannot exceed 256 characters",
                  },
                }),
              }}
        />
      </div>
      <div className="lg:flex w-full gap-4">
        <InputField
          name={"Keywords"}
          placeholder={"Enter keywords"}
          className="my-2 w-full"
          inputClassName="h-9"
          required
              error={errors?.keywords}
              register={{
                ...register("keywords", {
                  required: "Keywords is required",
                }),
              }}
        />
      </div>
      <div className="lg:h-80 h-96 mb-24 lg:mb-0">
        <label
          htmlFor="content"
          className="font-medium text-gray-600 text-sm my-[2px]"
        >
          Description
        </label>
        <Controller
          name="description"
          control={control}
          defaultValue=""
          rules={{
            required: "Description is required",
            minLength: {
              value: 10,
              message: "Description must be at least 10 characters long"
            },
           
            validate: (value) => value.trim()?.length > 0 || "Description cannot be empty"
          }}
          render={({ field }) => <TextEditor field={field} errors={errors?.description}/>}
        />
       
      </div>
      
    </FormLayout>
  );
};

export default AddBlog;
